import Page from 'component/Page';
import { useEffect } from 'react';
import { useState } from 'react';
import sendRequest, { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
import AppChannelAdd from './AppChannelAdd';
import AppChannelUpdate from './AppChannelUpdate';
// import UserMaintenance from './UserMaintenance';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import { formatDate, getString, showConfirm, showToast, nNU } from 'util/utils';

export const accountRoleNameMap = {
  0: string.ACCOUNT_ROLE_ADMIN,
  1: string.ACCOUNT_ROLE_PARENT,
  2: string.ACCOUNT_ROLE_CHILD,
};

export const accountStatusNameMap = {
  true: string.ACTIVE,
  false: string.INACTIVE,
};

const AppUserList = () => {
  const currentUser = useSelector(selectCurrentUser);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [addChannel, setAddChannel] = useState(null);
  const [selectedChannel, setSelectedChannel] = useState(null);

  const doSearch = useCallback(
    async (page, pageSize, getAll = false) => {
      let data = await sendPost({
        url:
          currentUser.accountRole === ACCOUNT_ROLE_ADMIN
            ? Urls.appchannel.list
            : Urls.appchannel.childlist,
        body: {
          id: currentUser.id,
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: '',
        },
      });
      const { total, result } = data;
      if (!getAll) {
        setUsers(result);
        setTotal(total);
      }
      return result;
    },
    [currentUser],
  );

  useEffect(() => {
    doSearch(page, pageSize);
  }, [page, pageSize, doSearch]);

  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
        key: raw.id,
        data: (currentUser.accountRole === ACCOUNT_ROLE_ADMIN) ? [
          raw.groupName,
					raw.email,
          !nNU(raw.registrationStatus) || raw.registrationStatus === 1
            ? string.APP_CHANNEL_STATUS_CONFIRM
            : raw.registrationStatus === 0
            ? string.APP_CHANNEL_STATUS_OK
            : string.APP_CHANNEL_STATUS_NG,
          !nNU(raw.registrationStatus) || raw.registrationStatus === 1
            ? '****/**/**'
            : formatDate(raw.registerDate, 'YYYY/MM/DD'),
          // !nNU(raw.registrationStatus) || raw.registrationStatus === 1
          //   ? '****/**/**'
          //   : formatDate(raw.expirationDate, 'YYYY/MM/DD'),
        ] : [
          raw.groupName,
					// raw.email,
          !nNU(raw.registrationStatus) || raw.registrationStatus === 1
            ? string.APP_CHANNEL_STATUS_CONFIRM
            : raw.registrationStatus === 0
            ? string.APP_CHANNEL_STATUS_OK
            : string.APP_CHANNEL_STATUS_NG,
          !nNU(raw.registrationStatus) || raw.registrationStatus === 1
            ? '****/**/**'
            : formatDate(raw.registerDate, 'YYYY/MM/DD'),
          // !nNU(raw.registrationStatus) || raw.registrationStatus === 1
          //   ? '****/**/**'
          //   : formatDate(raw.expirationDate, 'YYYY/MM/DD'),
				],
        raw,
      })),
    [],
  );

  return (
    <>
      <Page
        title={string.APP_CHANNEL_MANAGEMENT}
        body={
          <>
            <Table
              className="nowrap"
              mainActions={[
                {
                  icon: 'add',
                  title: string.APP_CHANNEL_ADD,
                  onClick: () => setAddChannel({ valid: true }),
                },
              ]}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={(currentUser.accountRole === ACCOUNT_ROLE_ADMIN) ? [
                string.APP_CHANNEL_NAME,
                string.APP_CHANNEL_OWNER,
                string.APP_CHANNEL_STATUS,
                string.APP_ACTIVATION_DATE,
                // string.APP_EXPIRATION_DATE,
              ] : [
                string.APP_CHANNEL_NAME,
                // string.APP_CHANNEL_OWNER,
                string.APP_CHANNEL_STATUS,
                string.APP_ACTIVATION_DATE,
                // string.APP_EXPIRATION_DATE,
							]}
              data={dataTable(users)}
              getCSVData={async () => {
                return dataTable(await doSearch(1, total, true));
              }}
              csvFileName="AppChannelList"
              actions={[
                {
                  render: 'edit',
                  onClick: ({ raw }) => setSelectedChannel(raw),
                },
                // ...(currentUser.accountRole === ACCOUNT_ROLE_ADMIN
                //   ? [
                //       {
                //         render: 'minus',
                //         className: 'color-danger',
                //         onClick: ({ raw }) => {
                //           showConfirm({
                //             body: getString(string.ACCOUNT_DELETE_CONFIRM, [
                //               raw.accountName,
                //             ]),
                //             defaultAction: () => {
                //               sendRequest({
                //                 url: `${Urls.user.update}/${raw.accountId}`,
                //                 method: 'delete',
                //               }).then(() => {
                //                 showToast(
                //                   string.ACCOUNT_DELETED_ALERT,
                //                   'success',
                //                 );
                //                 doSearch(page, pageSize);
                //               });
                //             },
                //           });
                //         },
                //       },
                //     ]
                //   : []),
              ]}
            />
          </>
        }
      />
      <Modal
        show={!!selectedChannel}
        onHide={() => setSelectedChannel(null)}
        body={
          <>
            {!!selectedChannel && (
              <AppChannelUpdate
                onUpdated={() => {
                  setSelectedChannel(null);
                  doSearch(page, pageSize);
                }}
                data={selectedChannel}
              />
            )}
          </>
        }
      />
      <Modal
        show={!!addChannel}
        onHide={() => setAddChannel(null)}
        body={
          <>
            {!!addChannel && (
              <AppChannelAdd
                onUpdated={() => {
                  setAddChannel(null);
                  doSearch(page, pageSize);
                }}
                data={addChannel}
              />
            )}
          </>
        }
      />
    </>
  );
};

export default AppUserList;
